// Per unit divisor is the currency conversion factor! Since variantPrice is stored in the base currency, we need to divide by the conversion factor to get the price per unit in the base currency.
// For example, if the variantPrice is 100 NIS and the conversion factor is 3.5, then the price per unit is 100 / 3.5 = 28.57 NIS.
const UNIT_CONFIG = {
  "ק״ג": {
    perUnit: "ל100 גרם",
    perUnitDivisor: 1000,
  },
  ליטר: {
    perUnit: 'ל100 מ"ל',
    perUnitDivisor: 1000,
  },
  יחידות: {
    perUnit: "ליחידה",
    perUnitDivisor: 100,
  },
  מטר: {
    perUnit: "למטר",
    perUnitDivisor: 100,
  },
};

function getUnitConfig(volumeUnit) {
  return UNIT_CONFIG[volumeUnit] ?? null;
}

function getPricePerUnit(price, volume, divisor) {
  return `${(price / volume / divisor).toFixed(2)} ₪`;
}

function initBoaPricePerUnit(element, dataset) {
  const {
    variantPrice,
    variantVolume,
    variantVolumeUnit,
    variantTextualVolume,
  } = dataset;
  const volumeSpan = element?.querySelector(".boa-price-per-unit__volume");
  const priceInfoSpan = element?.querySelector(
    ".boa-price-per-unit__price-info",
  );
  const separatorSpan = element?.querySelector(
    ".boa-price-per-unit__separator",
  );
  const priceSpan = element?.querySelector(".boa-price-per-unit__price");
  const unitTextSpan = element?.querySelector(".boa-price-per-unit__unit-text");
  const perUnitTextSpan = element?.querySelector(
    ".boa-price-per-unit__per-unit-text",
  );

  const price = Number(variantPrice);
  const volume = Number(variantVolume);
  const textualVolume = variantTextualVolume?.trim();
  const unitConfig = getUnitConfig(variantVolumeUnit);
  const canShowPrice = Boolean(price && volume && unitConfig);

  if (
    !volumeSpan ||
    !priceInfoSpan ||
    !separatorSpan ||
    !priceSpan ||
    !unitTextSpan ||
    !perUnitTextSpan
  ) {
    element.style.display = "none";
    return;
  }

  if (!textualVolume && !canShowPrice) {
    element.style.display = "none";
    return;
  }

  volumeSpan.textContent = textualVolume ?? "";
  unitTextSpan.textContent = "";
  separatorSpan.style.display = textualVolume ? "inline" : "none";

  if (canShowPrice) {
    priceSpan.textContent = getPricePerUnit(
      price,
      volume,
      unitConfig.perUnitDivisor,
    );
    perUnitTextSpan.textContent = unitConfig.perUnit;
    priceInfoSpan.style.display = "inline";
  } else {
    priceSpan.textContent = "";
    perUnitTextSpan.textContent = "";
    priceInfoSpan.style.display = "none";
  }

  element.style.display = "block";
}

document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("change", (event) => {
    const input = event.target;
    if (!input.matches?.("input[data-variant-textual-volume]")) return;

    const pricePerUnitElement = input
      .closest("product-info")
      ?.querySelector(".boa-price-per-unit");
    if (!pricePerUnitElement) return;

    initBoaPricePerUnit(pricePerUnitElement, input.dataset);
  });
});
